import { Api } from '@teko-builder/utils';

const pmBffUrl = {
    local: 'http://localhost:8081',
    dev: 'https://builder-bff.dev.tekoapis.net',
    stag: 'https://builder-bff.stag.tekoapis.net',
    production: 'https://builder-bff.tekoapis.com',
    'test-1': 'https://builder-bff.test-1.tekoapis.net',
    internal: 'http://builder-bff-api.page-management',
};
class Builder {
    constructor() {
        this.accessTokenInterceptor = (request) => {
            if (this.config.Authorization) {
                request.headers.set('Authorization', this.config.Authorization);
            }
            return request;
        };
    }
    init(domain, config) {
        this.domain = domain;
        if (!config.env) {
            config.env = 'production';
        }
        this.config = config;
        this.pageManagementClient = new Api(pmBffUrl[config.env]);
        this.pageManagementClient.addInterceptor(this.accessTokenInterceptor);
        this.internalClient = new Api(pmBffUrl.internal);
    }
    async getPublicPage(params, internal = false) {
        const client = internal ? this.internalClient : this.pageManagementClient;
        const { data } = await client.get('/v1/public/page', {
            params: Object.assign(Object.assign({}, params), { domain: this.domain }),
        });
        return data === null || data === void 0 ? void 0 : data.data;
    }
}
Builder.ITEMS_PER_PAGE = 18;
const builder = new Builder();

export { builder };
